/**
 * PDP Size Selector
 * - Keeps product title (h1) and browser tab title free of selected size
 * - Updates in-stock label beside the size header when variant changes
 */
(function () {
  'use strict';

  var originalDocumentTitle = null;

  function lockProductTitles() {
    document.querySelectorAll('[data-product-title-lock]').forEach(function (el) {
      var locked = el.getAttribute('data-product-title-lock');
      if (!locked) {
        return;
      }

      var link = el.querySelector('a');

      if (link) {
        if (link.textContent.trim() !== locked) {
          link.textContent = locked;
        }
        return;
      }

      if (el.textContent.trim() !== locked) {
        el.textContent = locked;
      }
    });
  }

  function lockDocumentTitle() {
    if (originalDocumentTitle === null) {
      originalDocumentTitle = document.title;
      return;
    }

    if (document.title !== originalDocumentTitle) {
      document.title = originalDocumentTitle;
    }
  }

  function updateSizeStock(variant) {
    document.querySelectorAll('[data-size-stock]').forEach(function (stockEl) {
      var inStock = stockEl.querySelector('.product-form__size-stock-text--in');
      var outStock = stockEl.querySelector('.product-form__size-stock-text--out');

      if (!variant) {
        return;
      }

      if (variant.available) {
        if (inStock) inStock.hidden = false;
        if (outStock) outStock.hidden = true;
      } else {
        if (inStock) inStock.hidden = true;
        if (outStock) outStock.hidden = false;
      }
    });
  }

  function initTitleLock() {
    lockProductTitles();
    originalDocumentTitle = document.title;

    document.querySelectorAll('[data-product-title-lock]').forEach(function (el) {
      var observer = new MutationObserver(function () {
        lockProductTitles();
      });

      observer.observe(el, {
        childList: true,
        characterData: true,
        subtree: true
      });
    });
  }

  document.addEventListener('variant:changed', function (event) {
    lockProductTitles();
    lockDocumentTitle();
    updateSizeStock(event.detail.variant);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTitleLock);
  } else {
    initTitleLock();
  }
})();
